export const filterByCategories = selected => categories => selected.length
    ? categories.filter(category => selected.includes(category.cid))
    : categories;

export const filterByFeatures = (selected, features) => categories => selected.length
    ? categories.map(category => ({
        ...category,
        gameCodes: category.gameCodes.filter(code => selected.some(
            selectedFeature => code in features
                ? Boolean(features[code][selectedFeature])
                : false
        ))
    }))
    : categories;

export const filterByVolatility = (selected = '', features) => categories => selected.length
    ? categories.map(category => ({
        ...category,
        gameCodes: category.gameCodes.filter(
            code => code in features
                ? features[code].volatility === selected
                : false
        )
    }))
    : categories;

export const filterByEmptyGames = categories => categories.filter(({ gameCodes }) => gameCodes.length);

export const filterByProviders = (selected, providers) => categories => selected.length
    ? categories.map(category => ({
        ...category,
        gameCodes: category.gameCodes.filter((code) => Boolean(Object.prototype.hasOwnProperty.call(providers, code)
            && selected.includes(providers[code].description)))
    }))
    : categories;
